<template>
  <div>
    <el-alert
      ref="alert"
      v-bind="$attrs"
      v-on="$listeners"
      :closable="closable"
      :type="type"
      :class="[getBorder(), color]">
    <slot></slot>
    <template #title>
      <slot name="title"></slot>
    </template>
  </el-alert>
  </div>
</template>

<script>
  export default {
    name: "gj-alert",
    props: {
      closable: {
        type: Boolean,
        default: false
      },
      border: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: 'info'  // info、success、warning、error
      },
      iconColor: {
        type: String,
        default: ''
      }
    },
    computed: {
      color() {
        if (!this.iconColor) return ''
        return `gj-alert-icon--${this.iconColor}`
      }
    },
    methods: {
      getBorder() {
        if (this.border) {
          return `gj-alert-${this.type}--border`
        }
        return '';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-alert--info {
    font-size: 12px;
    background-color: #EDF7FF;
    border-radius: 2px;
  }
  .el-alert--info /deep/ .el-alert__description {
    color: rgba(0,0,0,.65);
  }
  /deep/ .el-alert__icon.el-icon-info {
    color: #1F6EEF;
  }
  .gj-alert-info--border {
    border: 1px solid #9CCCFF;
  }

  .el-alert--success {
    font-size: 12px;
    background-color: #F0FAF2;
    border-radius: 2px;
  }
  .el-alert--success /deep/ .el-alert__description {
    color: rgba(0,0,0,.65);
  }
  /deep/ .el-alert__icon.el-icon-success {
    color: #52c41a;
  }
  .gj-alert-success--border {
    border: 1px solid #66BE74;
  }

  .el-alert--warning {
    font-size: 12px;
    background-color: #FFF5ED;
    border-radius: 2px;
    // border: 1px solid #F6BB90;
  }
  .el-alert--warning /deep/ .el-alert__description {
    color: rgba(0,0,0,.65);
  }
  /deep/ .el-alert__icon.el-icon-warning {
    color: #ED6A0C;
  }
  .gj-alert-warning--border {
    border: 1px solid #F6BB90;
  }

  .el-alert--error {
    font-size: 12px;
    background-color: #FFF1F0;
    border-radius: 2px;
  }
  .el-alert--error /deep/ .el-alert__description {
    color: rgba(0,0,0,.65);
  }
  /deep/ .el-alert__icon.el-icon-error {
    color: #F5222D;
  }
  .gj-alert-error--border {
    border: 1px solid #ffa39e;
  }

  /deep/ .el-alert__icon.is-big {
    font-size: 20px;
    width: 20px;
  }
  /deep/ .el-alert__description {
    margin: 0;
  }
  /deep/ .el-alert__title {
    font-size: 12px;
  }
  /deep/ .el-alert{
    align-items: flex-start;
  }
  /deep/ .el-alert__icon {
    margin-top: 1px;
  }
  .gj-alert-icon--info{
    /deep/ .el-alert__icon{
      color: #999999;
    }
  }
  /deep/ .el-alert__content{
    margin-left: 4px;
  }
</style>
